module.exports = __webpack_public_path__ + "static/img/cardInfo.563f7ff.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/cardInfo.webp
// module id = vloz
// module chunks = 0